import { Button, Dropdown, Space } from "antd";
import type { TableRowActionsMenuItem } from "~components/DataTable/types/tableRowActionsMenuItem.ts";

type Props = {
  tableRowActionsMenuItems: TableRowActionsMenuItem[];
};

export const TableRowActionsMenu = ({ tableRowActionsMenuItems }: Props) => {
  return (
    <Space style={{ columnGap: "0px" }}>
      {tableRowActionsMenuItems.length > 0 && (
        <Dropdown
          menu={{
            items: tableRowActionsMenuItems.map((item) => ({
              key: item.key,
              label: item.label,
              disabled: item.disabled,
            })),
          }}
        >
          <Button type={"text"} size={"small"} icon={<i className="fa-solid fa-ellipsis-vertical" />} />
        </Dropdown>
      )}
    </Space>
  );
};
